export const betResponseCode = {
  0: 'Success',
  1: 'GeneralError',
  2: 'InValidMinBet',
  3: 'InValidMaxBet',
  4: 'InvalidBet',
  5: 'NotEnoughBalance',
  6: 'MoneyTransactionError',
  7: 'UnAuthorizedUser',
  8: 'InvalidBetTime',
  9: 'InvalidRoundId',
  10: 'InValidBetData',
  11: 'InValidToken',
  12: 'DoChipWarning',
  13: 'MaxBetLimit',
};
export const betResponseCodeByName = {
  Success: 0,
  GeneralError: 1,
  InValidMinBet: 2,
  InValidMaxBet: 3,
  InvalidBet: 4,
  NotEnoughBalance: 5,
  MoneyTransactionError: 6,
  UnAuthorizedUser: 7,
  InvalidBetTime: 8,
  InvalidRoundId: 9,
  InValidBetData: 10,
  InValidToken: 11,
  DoChipWarning: 12,
  MaxBetLimit: 13,
  NotFreeChip: 1007,
};
